import {
  GET_COLLECTION_NAME_VERIFY,
  GET_COLLECTION_NAME_VERIFY_FAIL,
  GET_COLLECTION_NAME_VERIFY_SUCCESS,
  GET_COLLECTION_BYTECODE,
  GET_COLLECTION_BYTECODE_FAIL,
  GET_COLLECTION_BYTECODE_SUCCESS,
  GET_COLLECTIONS,
  GET_COLLECTIONS_FAIL,
  GET_COLLECTIONS_SUCCESS,
  POST_COLLECTION,
  POST_COLLECTION_FAIL,
  POST_COLLECTION_SUCCESS,
  GET_COLLECTION,
  GET_COLLECTION_BY_ADDRESS,
  GET_COLLECTION_FAIL,
  GET_COLLECTION_SUCCESS,
  PUT_COLLECTION,
  PUT_COLLECTION_FAIL,
  PUT_COLLECTION_SUCCESS,
  DELETE_COLLECTION,
  DELETE_COLLECTION_FAIL,
  DELETE_COLLECTION_SUCCESS,
  GET_COLLECTIONS_SUCCESS2,
  GET_COLLECTIONS_FAIL2,
  GET_COLLECTIONS2,
  POST_NEW_COLLECTION,
  POST_NEW_COLLECTION_FAIL,
  POST_NEW_COLLECTION_SUCCESS,
  GET_NEW_COLLECTIONS_BY_EMAIL_START,
  GET_NEW_COLLECTIONS_BY_EMAIL_FAIL,
  GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS,
  PUT_NEW_COLLECTION_START,
  PUT_NEW_COLLECTION_FAIL,
  PUT_NEW_COLLECTION_SUCCESS,
  DELETE_NEW_COLLECTION_START,
  DELETE_NEW_COLLECTION_FAIL,
  DELETE_NEW_COLLECTION_SUCCESS,
  PUT_NEW_COLLECTION_BY_ID_START,
  PUT_NEW_COLLECTION_BY_ID_FAIL,
  PUT_NEW_COLLECTION_BY_ID_SUCCESS,
  GET_NEW_COLLECTION_BY_ID_START,
  GET_NEW_COLLECTION_BY_ID_FAIL,
  GET_NEW_COLLECTION_BY_ID_SUCCESS,
  GET_ALL_NEW_COLLECTION_BY_ID_START,
  GET_ALL_NEW_COLLECTION_START,
  GET_ALL_NEW_COLLECTION_FAIL,
  GET_ALL_NEW_COLLECTION_SUCCESS,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_START,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_FAIL,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS
} from "./actionTypes";

/* Verify Collection By Name */
export const getCollectionNameVerify = (name, callback) => ({
  type: GET_COLLECTION_NAME_VERIFY,
  payload: { name, callback },
});

export const getCollectionNameVerifySuccess = () => ({
  type: GET_COLLECTION_NAME_VERIFY_SUCCESS,
});

export const getCollectionNameVerifyFail = () => ({
  type: GET_COLLECTION_NAME_VERIFY_FAIL,
});
/* Verify Collection By Name */

/* Get Collection Bytecode */
export const getCollectionBytecode = (data, callback) => ({
  type: GET_COLLECTION_BYTECODE,
  payload: { data, callback },
});

export const getCollectionBytecodeSuccess = () => ({
  type: GET_COLLECTION_BYTECODE_SUCCESS,
});

export const getCollectionBytecodeFail = () => ({
  type: GET_COLLECTION_BYTECODE_FAIL,
});
/* Get Collection Bytecode */

/* Get collections */
export const getCollections = (data, callback) => ({
  type: GET_COLLECTIONS,
  payload: {data, callback},
});

export const getCollectionsSuccess = (data) => ({
  type: GET_COLLECTIONS_SUCCESS,
  payload: data,
});

export const getCollectionsFail = (error) => ({
  type: GET_COLLECTIONS_FAIL,
  payload: error,
});
/// get COLLECTIONS 2 
// export const getCollections2 = () => ({
//   type: GET_COLLECTIONS2,
//   // payload: data,
// });

// export const getCollections2Success = (data) => ({
//   type: GET_COLLECTIONS_SUCCESS2,
//   payload: data,
// });
// export const getCollectionsFail2 = (error) => ({
//   type: GET_COLLECTIONS_FAIL2,
//   payload: error,
// });

// get collection by email
// export const getCollectionsByEmail = () => ({
//   type: GET_COLLECTION_BY_EMAIL,
//   // payload: data,
// });

// export const getCollectionsByEmailSuccess = (data) => ({
//   type: GET_COLLECTION_EMAIL_SUCCESS,
//   payload: data,
// });
// export const getCollectionsByEmailFail = (error) => ({
//   type: GET_COLLECTION_EMAIL_FAIL,
//   payload: error,
// });

/* Get Collections END */

/* Add Collection */
export const postCollection = (collection, callback) => ({
  type: POST_COLLECTION,
  payload: { collection, callback },
});
export const postCollectionFail = (error) => ({
  type: POST_COLLECTION_FAIL,
  payload: error,
});

export const postCollectionSuccess = () => ({
  type: POST_COLLECTION_SUCCESS,
});


//add NEW_COLLECTION
// export const postNewCollection = (collection, callback) => ({
//   type: POST_NEW_COLLECTION,
//   payload: { collection, callback },
// });
// export const postNewCollectionFail = (collection, callback) => ({
//   type: POST_NEW_COLLECTION_FAIL,
//   payload: { collection, callback },
// });
// export const postNewCollectionSuccess = () => ({
//   type: POST_NEW_COLLECTION_SUCCESS,
// });
/* Add Collection END */
/// get COLLECTIONS 2
export const getCollections2 = () => ({
  type: GET_COLLECTIONS2,
  // payload: data,
});
export const getCollections2Success = (data) => ({
  type: GET_COLLECTIONS_SUCCESS2,
  payload: data,
});
export const getCollectionsFail2 = (error) => ({
  type: GET_COLLECTIONS_FAIL2,
  payload: error,
});
/* Get Collection */
export const getCollection = (id, callback) => ({
  type: GET_COLLECTION,
  payload: { id, callback },
});

export const getCollectionByAddress = (address, callback) => ({
  type: GET_COLLECTION_BY_ADDRESS,
  payload: { address, callback },
});

export const getCollectionFail = (error) => ({
  type: GET_COLLECTION_FAIL,
  payload: error,
});

export const getCollectionSuccess = (data) => ({
  type: GET_COLLECTION_SUCCESS,
  payload: data,
});
/* Get Collection END */

/* Update Collection */
export const putCollection = (data, callback) => ({
  type: PUT_COLLECTION,
  payload: { data, callback },
});

export const putCollectionFail = (error) => ({
  type: PUT_COLLECTION_FAIL,
  payload: error,
});

export const putCollectionSuccess = () => ({
  type: PUT_COLLECTION_SUCCESS,
});
/* Update Collection END */

/* Delete Collection */
export const deleteCollection = (data, callback) => ({
  type: DELETE_COLLECTION,
  payload: { data, callback },
});

export const deleteCollectionFail = (error) => ({
  type: DELETE_COLLECTION_FAIL,
  payload: error,
});

export const deleteCollectionSuccess = () => ({
  type: DELETE_COLLECTION_SUCCESS,
});
/* Delete Collection END */


//new collection
export const postNewCollection = (collection, callback) => ({
  type: POST_NEW_COLLECTION,
  payload: { collection, callback },
});
export const postNewCollectionFail = (collection, callback) => ({
  type: POST_NEW_COLLECTION_FAIL,
  payload: { collection, callback },
});
export const postNewCollectionSuccess = () => ({
  type: POST_NEW_COLLECTION_SUCCESS,
});
export const getNewCollectionByEmailStart = (data, callback) => ({
  type: GET_NEW_COLLECTIONS_BY_EMAIL_START,
  payload: { data, callback },
});
export const getNewCollectionByEmailFail = (data, callback) => ({
  type: GET_NEW_COLLECTIONS_BY_EMAIL_FAIL,
  payload: { data, callback },
});
export const getNewCollectionByEmailSuccess = (data) => ({
  type: GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS,
  payload: data,
});


export const putNewCollectionByEmailStart = (collection, callback) => ({
  type: PUT_NEW_COLLECTION_START,
  payload: { collection, callback },
});
export const putNewCollectionByEmailFail = (collection, callback) => ({
  type: PUT_NEW_COLLECTION_FAIL,
  payload: { collection, callback },
});
export const putNewCollectionByEmailSuccess = (data) => ({
  type: PUT_NEW_COLLECTION_SUCCESS,
  payload: data ,
});



export const deleteNewCollectionStart = (data, callback) => ({
  type: DELETE_NEW_COLLECTION_START,
  payload: { data, callback },
});
export const deleteNewCollectionFail = (error) => ({
  type: DELETE_NEW_COLLECTION_FAIL,
  payload: error
});
export const deleteNewCollectionSuccess = (data) => ({
  type: DELETE_NEW_COLLECTION_SUCCESS,
});


export const EditNewColllectionStart = (data, callback) => ({
  type: DELETE_NEW_COLLECTION_START,
  payload: { data, callback },
});
export const EditNewColllectionFail = (error) => ({
  type: DELETE_NEW_COLLECTION_FAIL,
  payload: error
});
export const EditNewColllectionSuccess = (data) => ({
  type: DELETE_NEW_COLLECTION_SUCCESS,
});

//get new collection by id

export const getNewCollectionByIdStart = (id, callback) => ({
  type: GET_NEW_COLLECTION_BY_ID_START,
  payload: { id, callback },
});
export const getNewCollectionByIdFail = (collection, callback) => ({
  type: GET_NEW_COLLECTION_BY_ID_FAIL,
  payload: { collection, callback },
});
export const getNewCollectionByIdSuccess = (data) => ({
  type: GET_NEW_COLLECTION_BY_ID_SUCCESS,
  payload: data ,
});

//update new collection by id 
export const putNewCollectionByIdStart = (collection, callback) => ({
  type: PUT_NEW_COLLECTION_BY_ID_START,
  payload: { collection, callback },
});
export const putNewCollectionByIdFail = (collection, callback) => ({
  type: PUT_NEW_COLLECTION_BY_ID_FAIL,
  payload: { collection, callback },
});
export const putNewCollectionByIdSuccess = (data) => ({
  type: PUT_NEW_COLLECTION_BY_ID_SUCCESS,
  payload: data ,
});

// get all collection
export const getAllNewCollections = (email, callback) => ({
  type: GET_ALL_NEW_COLLECTION_START,
  payload: { email, callback },
});
export const getAllNewCollectionsFail = (data, callback) => ({
  type: GET_ALL_NEW_COLLECTION_FAIL,
  payload: { data, callback },
});
export const getAllNewCollectionsSuccess = (data) => ({
  type: GET_ALL_NEW_COLLECTION_SUCCESS,
  payload: data,
});

export const getAllNewCollectionsWithFilter = (email, callback) => ({
  type: GET_ALL_NEW_COLLECTION_WITH_FILTER_START,
  payload: { email, callback },
});
export const getAllNewCollectionsWithFilterFail = (data, callback) => ({
  type: GET_ALL_NEW_COLLECTION_WITH_FILTER_FAIL,
  payload: { data, callback },
});
export const getAllNewCollectionsWithFilterSuccess = (data) => ({
  type: GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS,
  payload: data,
});